module.exports = __webpack_public_path__ + "media/images/v2/kwivrr-meet-icon-66e5a3f5a472546f023aa0f6b8df3d62.png";